<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <Modal v-if="showModalListDocuments" :widthContainer="'90% !important'" :heightContainer="'50% !important'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#174a84;">{{modalTitle}}</h3>
      <div slot="body">
        <div class="">
          <div class="grid grid-cols-2 gap-4" style="border: 1px solid #12B3BD;padding:10px;margin-top:10px;"
           v-for="(document, index) in documents_list_filtered" :key="index">
            <div style="">
              <p style="width:70%;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:500;">Documento:</p>
              <p style="width:70%;word-wrap: break-word;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:300;">
                {{ `${document.name}.${document.extension}` }}
              </p>
            </div>
            <div>
              <input type="button" value="Eliminar" class="deleteDocumentButton" style="float:right;"
                v-on:click="deleteDocument(document.document_abbreviation, document.name)">
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="showModalListDocuments = false">
      </div>
    </Modal>
    <div>
      <form @submit="save">
        <div style="margin-top:20px;">
          <div>
            <PersonalInfo title="Datos personales" :name="`${paternalName} ${maternalName} ${name}`" :rfc="rfc" />
          </div>
          <div style="margin-top:20px;">
            <p class="personalInfoTitle">Ingresar los datos siguientes:</p>
          </div>
          <div style="margin-top:10px;">
            <div class="mb-4">
              <input class="inputsForm" id="personalinfo_email" type="text" v-model.trim="$v.email.$model" 
                :class="{'inputs-invalid-form':$v.email.$error, 'inputsForm':!$v.email.$invalid}" 
                placeholder="Correo Electrónico" />
              <div class="content-text">
                <div v-if="$v.email.$error" class="text">
                  <span class="errors" v-if="!$v.email.required">El correo electrónico es requerido</span>
                  <span class="errors" v-if="!$v.email.isUnique">El formato del correo electrónico no es correcto. (su-correo@ejemplo.com)</span>
                </div>
              </div>
            </div>
            <div class="mb-4" style="">
              <input class="inputsForm" id="personalinfo_cellphone"  type="text" placeholder="Celular" 
               :class="{'inputs-invalid-form':$v.cellphone.$error, 'inputsForm':!$v.cellphone.$invalid}" 
               v-mask="'### ###-####'" v-model.trim="$v.cellphone.$model" />
              <div class="content-text">
                <div v-if="$v.cellphone.$error" class="text">
                  <span class="errors" v-if="!$v.cellphone.required">El celular es requerido</span>
                  <span class="errors" v-if="!$v.cellphone.minLength">Debe ingresar los 10 dígitos del celular</span>
                  <span class="errors" v-if="!$v.cellphone.maxLength">Debe ingresar los 10 dígitos del celular</span>
                </div>
              </div>
            </div>
            <div class="mb-4" style="">
              <input class="inputsForm" id="personalinfo_interbank_clabe" type="text" placeholder="Clabe Interbancaria"
                :class="{'inputs-invalid-form':$v.InterbankClabe.$error, 'inputsForm':!$v.InterbankClabe.$invalid}"
                v-mask="'##################'" v-model.trim="$v.InterbankClabe.$model" />
              <div class="content-text">
                <div v-if="$v.InterbankClabe.$error" class="text">
                  <span class="errors" v-if="!$v.InterbankClabe.required">La clabe interbancaria es requerida</span>
                  <span class="errors" v-if="!$v.InterbankClabe.minLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
                  <span class="errors" v-if="!$v.InterbankClabe.maxLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
                </div>
              </div>
            </div>
            <div class="mb-4" style="">
              <select class="inputsForm" id="personalinfo_bank" v-model.trim="$v.bank.$model"
                :class="{'inputs-invalid-form':$v.bank.$error, 'inputsForm':!$v.bank.$invalid}">
                <option value="Banco" selected hidden>Banco</option>
                <option v-for="bank in list_banks" :key="bank.id" :value="bank.name">{{bank.name}}</option>
              </select>
              <div class="content-text">
                <div v-if="$v.bank.$error" class="text">
                  <span class="errors" v-if="!$v.bank.isUnique">El banco es requerido</span>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top:30px;">
            <p class="titleComponent">Solicitar Préstamo</p>
            <p class="totalSaved">{{ saving | currency }}</p>
            <p class="textUnderTotalSaved">Total ahorrado</p>
          </div>
          <div style="margin-top:30px;">
            <p class="titleComponent">Tipo de Préstamo</p>
            <div class="containerLoanTypeButtons">
              <div class="contentLoanTypeButtons">
                <div v-if="existOrdinaryLoanType">
                  <input type="button" value="Ordinarios" 
                  v-on:click="filterLoanCatalogByType('ordinario')" class="LoanTypeButton" id="LoanTypeOrdinaryButton"
                  v-bind:style="{
                    backgroundColor: isLoanTypeActive('ordinario')  ? activeColorBackground : inactiveColorBackground, 
                    color: isLoanTypeActive('ordinario') ? activeColorText : inactiveColorText
                  }" />
                </div>
                <div v-if="existSpecialLoanType">
                  <input type="button" value="Especiales" 
                  v-on:click="filterLoanCatalogByType('especial')" class="LoanTypeButton" id="LoanTypeSpecialButton"
                  v-bind:style="{
                    backgroundColor: isLoanTypeActive('especial')  ? activeColorBackground : inactiveColorBackground, 
                    color: isLoanTypeActive('especial') ? activeColorText : inactiveColorText
                  }" />
                </div>
                <div v-if="existAutoLoanType">
                  <input type="button" value="Autos" 
                  v-on:click="filterLoanCatalogByType('auto')" class="LoanTypeButton" id="LoanTypeAutoButton"
                  v-bind:style="{
                    backgroundColor: isLoanTypeActive('auto')  ? activeColorBackground : inactiveColorBackground, 
                    color: isLoanTypeActive('auto') ? activeColorText : inactiveColorText
                  }" />
                </div>
                <div v-if="existLivingPlaceLoanType">
                  <input type="button" value="Vivienda" 
                  v-on:click="filterLoanCatalogByType('vivienda')" class="LoanTypeButton" id="LoanTypeLivingPlaceButton"
                  v-bind:style="{
                    backgroundColor: isLoanTypeActive('vivienda')  ? activeColorBackground : inactiveColorBackground, 
                    color: isLoanTypeActive('vivienda') ? activeColorText : inactiveColorText
                  }" />
                </div>
              </div>
            </div>
            <div class="contentLoanTypeTable">
              <table class="table loanTable">
                <thead>
                  <tr>
                    <th></th>
                    <th class="subHeaderMain">Tipo</th>
                    <th class="subHeaderMain">Monto</th>
                    <th class="subHeaderMain" rowspan="2">Plazo a pagar en quincenas</th>
                    <th class="subHeaderMain" colspan="2" rowspan="1">Tasa</th>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="subHeader">Interés Mensual</td>
                    <td class="subHeader">Garantía Sobre Monto</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(loan, i) in loan_catalog_filtered" :key="i">
                    <td><input type="radio" :value="loan.name" :id="loan.name" :name="loan.name" v-model="loanTypeSelected" v-on:change="addSelectedLoanType(loan_catalog_filtered[i])"></td>
                    <td>{{loan.name}}</td>
                    <td>{{loan.loan_amount | currency}}</td>
                    <td>{{loan.term}}</td>
                    <td>{{loan.interest_rate | percent}}</td>
                    <td>{{loan.guarantee_rate | percent}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="margin-top:30px;">
            <div>
              <p class="titleComponent">Adjuntar Documentos</p>
              <p class="personalInfoTitle" v-show="documents_list.length > 0">Para ver el detalle o eliminar un documento adjunto, de click al botón Detalle de Documentos.</p>
            </div>
            <div class="contentLoadDocumentTable">
              <table class="table loadDocumentTable">
                <thead>
                  <tr>
                    <th>Documento</th>
                    <th>Estatus</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="existCheckBookInDocumentsTypeByLoanType">
                    <td>Talón de cheques</td>
                    <td><Check v-show="loadCheckCheckBook" /></td>
                    <td style="width:40%;">
                      <input type="button" value="Cargar" id="loadDocumentCheckBookButton" class="loadDocumentButton" v-on:click="getFile('uploadFileCheckBook')"><br/>
                      <input v-show="loadCheckCheckBook" type="button" value="Detalle de Documentos" id="deleteDocumentCheckBookButton" class="loadDocumentButtonWithoutBackground" 
                        v-on:click="filterDocumentList('Talon', 'Talón de Cheques')" style="margin-top:10px;" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileCheckBook" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'Talon')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckIOInDocumentsTypeByLoanType">
                    <td>INE/IFE</td>
                    <td><Check v-show="loadCheckIO" /></td>
                    <td style="width:40%;">
                      <input v-show="!loadCheckIO" type="button" value="Cargar" id="loadDocumentIOButton" class="loadDocumentButton" v-on:click="getFile('uploadFileID')">
                      <input v-show="loadCheckIO" type="button" value="Detalle de Documentos" id="deleteDocumentIOButton" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('IO', 'Identificación')" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileID" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'IO')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckAccountStatusTypeByLoanType">
                    <td>Estado de Cuenta</td>
                    <td><Check v-show="loadCheckAccountStatus" /></td>
                    <td style="width:40%;">
                      <input v-show="!loadCheckAccountStatus" type="button" value="Cargar" id="loadDocumentAccountStatusButton" class="loadDocumentButton" v-on:click="getFile('uploadFileAccountStatus')">
                      <input v-show="loadCheckAccountStatus" type="button" value="Detalle de Documentos" id="deleteDocumentIOButton" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('EC', 'Estado de Cuenta')" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileAccountStatus" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'EC')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckCredentialInDocumentsTypeByLoanType">
                    <td>Credencial Sección 17</td>
                    <td><Check v-show="loadCheckCredential" /></td>
                    <td style="width:40%;">
                      <input v-show="!loadCheckCredential" type="button" value="Cargar" id="loadDocumentCredentialButton" class="loadDocumentButton" v-on:click="getFile('uploadFileCredential')">
                      <input v-show="loadCheckCredential" type="button" value="Detalle de Documentos" id="deleteDocumentCredentialButton" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('CRED17', 'Credencial Sección 17')" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileCredential" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'CRED17')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckProofResidencyInDocumentsTypeByLoanType">
                    <td>Comprobante de Domicilio</td>
                    <td><Check v-show="loadCheckProofResidency" /></td>
                    <td style="width:40%;">
                      <input v-show="!loadCheckProofResidency" type="button" value="Cargar" id="loadDocumentProofResidencyButton" class="loadDocumentButton" v-on:click="getFile('uploadFileProofResidency')">
                      <input v-show="loadCheckProofResidency" type="button" value="Detalle de Documentos" id="deleteDocumentProofResidencyButton" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('CD', 'Comprobante de Domicilio')" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileProofResidency" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'CD')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckPublicScriptureInDocumentsTypeByLoanType">
                    <td>Escritura Pública</td>
                    <td><Check v-show="loadCheckPublicScripture" /></td>
                    <td style="width:40%;">
                      <input v-show="!loadCheckPublicScripture" type="button" value="Cargar" id="loadDocumentPublicScriptureButton" class="loadDocumentButton" v-on:click="getFile('uploadFilePublicScripture')">
                      <input v-show="loadCheckPublicScripture" type="button" value="Detalle de Documentos" id="deleteDocumentPublicScriptureButton" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('EP', 'Escritura Pública')" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFilePublicScripture" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'EP')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckEvidenceEnlargementInDocumentsTypeByLoanType">
                    <td>Evidencias de la Ampliación</td>
                    <td><Check v-show="loadCheckEvidenceEnlargement" /></td>
                    <td style="width:40%;">
                      <input type="button" value="Cargar" id="loadDocumentEvidenceEnlargementButton" class="loadDocumentButton" v-on:click="getFile('uploadFileEvidenceEnlargement')">
                      <input v-show="loadCheckEvidenceEnlargement" type="button" value="Detalle de Documentos" id="deleteDocumentEvidenceEnlargementButton" class="loadDocumentButtonWithoutBackground" 
                        v-on:click="filterDocumentList('EPR', 'Evidencias de la Ampliación')" style="margin-top:10px;" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileEvidenceEnlargement" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'EPR')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckAutoQuoteInDocumentsTypeByLoanType">
                    <td>Cotización del Automóvil</td>
                    <td><Check v-show="loadCheckAutoQuote" /></td>
                    <td style="width:40%;">
                      <input v-show="!loadCheckAutoQuote" type="button" value="Cargar" id="loadDocumentAutoQuoteButton" class="loadDocumentButton" v-on:click="getFile('uploadFileAutoQuote')">
                      <input v-show="loadCheckAutoQuote" type="button" value="Detalle de Documentos" id="deleteDocumentAutoQuoteButton" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('COT', 'Cotización del Automóvil')" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileAutoQuote" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'COT')"/></div>
                    </td>
                  </tr>
                  <tr v-if="existCheckCreditRequestInDocumentsTypeByLoanType">
                    <td>Solicitud de Crédito</td>
                    <td><Check v-show="loadCheckCreditRequest" /></td>
                    <td style="width:40%;">
                      <input v-show="!loadCheckCreditRequest" type="button" value="Cargar" id="loadDocumentCreditRequestButton" class="loadDocumentButton" v-on:click="getFile('uploadFileCreditRequest')">
                      <input v-show="loadCheckCreditRequest" type="button" value="Detalle de Documentos" id="deleteDocumentCreditRequestButton" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('SOLCRED', 'Solicitud de Crédito')" />
                      <div style='height: 0px;width:0px; overflow:hidden;'><input id="uploadFileCreditRequest" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'SOLCRED')"/></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="margin-top:30px">
            <div>
              <button class="AccessButton" id="endProcessButton">Terminar Proceso</button>
            </div>
          </div>
          <div style="margin-top:10px">
            <div>
              <input type="button" value="Atrás" v-on:click="logout()" class="AccessButtonWithoutBackground" id="backButton">
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Check from '@/components/Loading/Check.vue'
import Swal from 'sweetalert2'
import Modal from '@/components/Modal/Modal.vue'
import User from '@/classes/User'
import Saving from '@/classes/Saving'
import Loan from '@/classes/Loan'
import Document from '@/classes/Document'
import Loading from '@/components/Loading/Loading.vue'
import PersonalInfo from '@/components/PersonalInfo/PersonalInfo.vue'
import { LoansType, LoansTypeDB } from '@/helpers/enums';
import { getBanks } from "@/api/bank";

import {validateEmail} from '@/helpers/email'
import {required, minLength, maxLength, email, requiredIf} from 'vuelidate/lib/validators'

import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      userObjectClass: null,
      savingObjectClass: null,
      loanObjectClass: null,
      documentObjectClass: null,
      token_auth: "",
      rfc: "",
      email: "",
      cellphone: "",
      InterbankClabe: "",
      loanTypeObjectSelected: null,
      loanTypeSelected: "",
      nameDocumentsArray: [],
      documents_list: [],
      documents_list_filtered: [],
      loan_catalog: [],
      loan_catalog_filtered: [],
      loadCheckCheckBook: false,
      loadCheckIO: false,
      loadCheckCredential: false,
      loadCheckProofResidency: false,
      loadCheckCreditRequest: false,
      loadCheckProofPayment: false,
      loadCheckPublicScripture: false,
      loadCheckEvidenceEnlargement: false,
      loadCheckAutoQuote: false,
      loadCheckAccountStatus: false,
      fullName: "",
      name: "",
      maternalName: "",
      paternalName: "",
      saving: 0,
      list_banks: [],
      documentsTypeByLoanType: [],
      bank: "Banco",
      existOrdinaryLoanType: false,
      existSpecialLoanType: false,
      existAutoLoanType: false,
      existLivingPlaceLoanType: false,
      existCheckBookInDocumentsTypeByLoanType: false,
      existCheckIOInDocumentsTypeByLoanType: false,
      existCheckCredentialInDocumentsTypeByLoanType: false,
      existCheckProofResidencyInDocumentsTypeByLoanType: false,
      existCheckCreditRequestInDocumentsTypeByLoanType: false,
      existCheckProofPaymentInDocumentsTypeByLoanType: false,
      existCheckPublicScriptureInDocumentsTypeByLoanType: false,
      existCheckEvidenceEnlargementInDocumentsTypeByLoanType: false,
      existCheckAutoQuoteInDocumentsTypeByLoanType: false,
      existCheckAccountStatusTypeByLoanType: false,
      isLoading: false,
      showModalListDocuments: false,
      modalTitle: '',
      loanId: 0,
      activeLoanTypeItem: "ordinario",
      activeColorBackground: "#198F99",
      inactiveColorBackground: "#fff",
      activeColorText: "#fff",
      inactiveColorText: "#222222",
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS
    }
  },
  validations: {
    email: {
      required,
      email,
      isUnique(value) {
        return validateEmail(value);
      }
    },
    cellphone: {
      required,
      minLength: minLength(12),
      maxLength: maxLength(12)
    },
    InterbankClabe: {
      required,
      minLength: minLength(18),
      maxLength: maxLength(18)
    },
    bank: {
      required,
      isUnique(value) {
        if (value == "Banco") {
          return false;
        }

        return true;
      }
    }
  },
  name:"PreRequestLoan",
  components: {
    Check,
    Modal,
    Loading,
    PersonalInfo
  },
  mounted() {
    this.userObjectClass = new User();
    this.savingObjectClass = new Saving();
    this.loanObjectClass = new Loan();
    this.documentObjectClass = new Document();
    this.isLogged();
    this.loadInfo();
    this.login();
  },
  methods: {
    loadInfo() {
      let auth = JSON.parse(window.localStorage.getItem('authenticate'));
      this.fullName = auth.full_name;
      this.name = auth.name;
      this.paternalName = auth.paternal_name;
      this.maternalName = auth.maternal_name;
      this.rfc = auth.rfc;
    },
    getBanks() {
      getBanks(this.token_auth).then(response => {
        this.list_banks = response.data.response.lista_bancos;
        console.log("banks: ", response);
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.token_auth = response.data.token_auth;
        console.log(this.token_auth);
        this.getBanks();
        this.getDocumentsTypeByLoanType();
        this.getSaving();
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getSaving() {
      this.savingObjectClass.getResumeByRfc(this.token_auth, this.rfc).then(response => {
        this.saving = response.data.response.savings.ahorro;
        this.getCatalogLoan();
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: "Se presentó un error al obtener el ahorro",
          icon: "error",
        });
      })
    },
    getCatalogLoan(){
      this.loanObjectClass.getCatalog(this.token_auth, this.saving).then(response => {
        this.isLoading = false;
        this.loan_catalog = response.data.response.catalog_loan;
        this.searchLoanTypeDescription();
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    validateCellPhone(){
      var input = document.getElementById('personalinfo_cellphone');
      input.oninvalid = input.setCustomValidity('');
      if(input.value.length > 0 && input.value.length < 12){
        input.oninvalid = input.setCustomValidity('Debe ingresar los 10 dígitos del número');
      }
    },
    validateInterbankClabe(){
      var input = document.getElementById('personalinfo_interbank_clabe');
      input.oninvalid = input.setCustomValidity('');
      if(input.value.length > 0 && input.value.length < 18){
        input.oninvalid = input.setCustomValidity('Debe ingresar los 18 dígitos de la clave Interbancaria');
      }
    },
    getFile(selector) {
      document.getElementById(selector).value ="";
      document.getElementById(selector).click();
    },
    validateEmail(email) {
      var regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      if (regex.test(email)) {
        return true;
      }
      return false;
    },
    loadDocument(event, type) {
      let files = event.target.files;
      let filename = files[0].name.split('.')[0].replace(/\s/g, '_');
      
      const fileReader = new FileReader();
      fileReader.onerror = this.errorHandler;

      if(this.documents_list.length > 0){
        if (!this.documentTypeReachItsLimit(type)) {
          if (this.existDocument(this.documents_list, filename)) {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: "El archivo seleccionado ya ha sido cargado",
              icon: "error",
            });
            return;
          } 
        } else {
          Swal.fire({
            title: "Aviso",
            text: "Solo puede subirse 5 documentos",
            icon: "error",
          });
          return;
        }
      }

      this.getFileReader(files, event, type);
    },
    deleteDocument(document, documentName){
      Swal.fire({
        title: "Aviso",
        text: '¿Desea eliminar el documento?',
        icon: "warning",
        customClass: {
          container: 'my-swal'
        },
        showCancelButton: true,
        confirmButtonColor: '#12B3BD',
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then((result) => {
        if (result.value) {
          let indexDocuments = this.documents_list.findIndex(d => d.document_abbreviation === document && d.name === documentName);
          let indexDocumentsFiltered = this.documents_list_filtered.findIndex(d => d.document_abbreviation === document && d.name === documentName);
          if (indexDocuments != -1) {
            this.documents_list.splice(indexDocuments,1);
            this.changeValueChecks(false, document);
          } 
          if (indexDocumentsFiltered != -1) {
            this.documents_list_filtered.splice(indexDocumentsFiltered,1);
          } 
        }
      });
    },
    getFileReader(files, event, type) {
      const fileReader = new FileReader();
      let extension = files[0].type.split('/')[1];
      let filename = files[0].name;
      fileReader.addEventListener('load', () => {
        let fileBase64 = fileReader.result.split(',')[1];
        event.target.value = null;
        this.setDocumentList({fileBase64: fileBase64,fileName: filename.split('.')[0].replace(/\s/g, '_'),extension: extension,type: type,table_id: 0,remote_folder: "FAS/loan_requests",rfc: this.rfc,});
        this.changeValueChecks(true, type);
      })
      fileReader.readAsDataURL(files[0]);
    },
    setDocumentList({fileBase64, fileName, extension, type, table_id, remote_folder, rfc}) {
      this.documents_list.push({
        file: fileBase64,
        name: fileName,
        extension: extension,
        document_abbreviation: type,
        table_id: table_id,
        remote_folder: remote_folder,
        rfc: rfc,
      });
    },
    documentTypeReachItsLimit(document) {
      let documents = this.documents_list.filter(d => d.document_abbreviation === document);
      if (documents.length >= 5) {
        return true;
      }
      return false;
    },
    existDocument(documents, newDocument) {
      let indexDocuments = documents.findIndex(d => d.name === newDocument);
      if (indexDocuments != -1) {
        return true;
      }
      return false;
    },
    save(e) {
      e.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoading = true;

        let isLoanTypeEmpty = this.isLoanTypeEmpty();
        if (!isLoanTypeEmpty) {
          this.isLoading = false;
          return;
        }

        let documentsComplete = this.areDocumentsComplete();
        if (!documentsComplete) {
          this.isLoading = false;
          return;
        }

        let preRequestLoan = this.buildObjectPreRequestLoan();

        this.loanObjectClass.register(preRequestLoan).then(response => {
          this.updateLoanRequestIdInDocumentList(response.data.response.loan_request.id);
          this.uploadDocument().then(response => {
            this.isLoading = false;
            Swal.fire({
              text: "Solicitud de prestamo guardada correctamente",
              html: `<p style="font-size:18px;font-weight:bold;">Se registró su solicitud de préstamo exitosamente.</p><br/>
                    <p style="font-size:14px;">Se procederá a la revisión de la documentación adjunta por parte del Comité Técnico, 
                    de estar correcta, en aproximadamente 5 días hábiles procederá su trámite.</p>`,
              
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
              icon: "success",
            }).then((response)=>{
              this.$router.push({ name: 'HomeLoanRequest' });
            });
          }).catch(error => {
            this.isLoading = false;
            console.log(error);
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            });
          });
        }).catch(error => {
          this.isLoading = false;
          console.log(error);
          Swal.fire({
            title: "Aviso",
            text: error,
            icon: "error",
          });
        });
      }
    },
    isLoanTypeEmpty() {      
      if (this.loanTypeSelected == "") {
        Swal.fire({
          title: "Aviso",
          text: "Favor de seleccionar un Tipo de Prestamo",
          icon: "warning",
        })
        return false;
      }

      return true;
    },
    cleanValueChecks() {
      this.loadCheckCheckBook = false;
      this.loadCheckIO = false;
      this.loadCheckCredential = false;
      this.loadCheckProofResidency = false;
      this.loadCheckCreditRequest = false;
      this.loadCheckAutoQuote = false;
      this.loadCheckPublicScripture = false;
      this.loadCheckEvidenceEnlargement = false;
      this.loadCheckAccountStatus = false;
    },
    changeValueChecks(value, document) {
      let index = -1;
      if (!value) {
        index = this.documents_list.findIndex(b => b.document_abbreviation === document);
        value = index != -1 ? true : value
      }

      switch (document) {
        case "Talon":
          this.loadCheckCheckBook = value;
          break;
        case "IO":
          this.loadCheckIO = value;
          break;
        case "CRED17":
          this.loadCheckCredential = value;
          break;
        case "CD":
          this.loadCheckProofResidency = value;
          break;
        case "SOLCRED":
          this.loadCheckCreditRequest = value;
          break;
        case "COT":
          this.loadCheckAutoQuote = value;
          break;
        case "EP":
          this.loadCheckPublicScripture = value;
          break;
        case "EPR":
          this.loadCheckEvidenceEnlargement = value;
          break;
        case "EC":
          this.loadCheckAccountStatus = value;
          break;
      }
    },
    addSelectedLoanType(value) {
      this.loanTypeObjectSelected = {
        category: LoansTypeDB[value.name],
        loan_name: value.name,
        term: value.term,
        guarantee_rate: value.guarantee_rate,
        interest_rate: value.interest_rate,
        loan_amount: value.loan_amount,
      }
      console.log("loan selected:", this.loanTypeObjectSelected);
    },
    buildObjectPreRequestLoan() {
      let preRequestLoan = {
        token_auth: this.token_auth,
        rfc: this.rfc,
        name: this.name,
        middle_name: this.name,
        maternal_name: this.maternalName,
        paternal_name: this.paternalName,
        email: this.email,
        amount_savings: this.saving,
        clabe: this.InterbankClabe,
        cellphone: this.removeMask(this.cellphone),
        bank_name: this.bank,
        loan_information: this.loanTypeObjectSelected
      }

      return preRequestLoan;
    },
    searchLoanTypeDescription() {
      if (this.loan_catalog.length > 0) {
        this.setLoanTypeButtonActive(LoansType[this.loan_catalog[0].name]);
        this.validateDocumentsTypeByLoanType(LoansType[this.loan_catalog[0].name]);
        for (let i = 0; i < this.loan_catalog.length; i++) {
          let type = LoansType[this.loan_catalog[i].name];
          switch (type) {
            case "ordinario":
              this.existOrdinaryLoanType = true;
              this.loan_catalog[i].category = LoansType[this.loan_catalog[i].name];
              break;
            case "especial":
              this.existSpecialLoanType = true;
              this.loan_catalog[i].category = LoansType[this.loan_catalog[i].name];
              break;
            case "auto":
              this.existAutoLoanType = true;
              this.loan_catalog[i].category = LoansType[this.loan_catalog[i].name];
              break;
            case "vivienda":
              this.existLivingPlaceLoanType = true;
              this.loan_catalog[i].category = LoansType[this.loan_catalog[i].name];
              break;
          } 
        }
        this.filterLoanCatalogByType(LoansType[this.loan_catalog[0].name]);
      }
    },
    removeMask(phone) {
      if (phone.includes("(")) {
        phone = phone.replace("(", "");
      }
      if (phone.includes(")")) {
        phone = phone.replace(")", "");
      }
      if (phone.includes("-")) {
        phone = phone.replace("-", "");
      }
      if (phone.includes(" ")) {
        phone = phone.replace(" ", "");
      }
      return phone;
    },
    updateLoanRequestIdInDocumentList(loanRequestId) {
      this.documents_list.forEach(item => item.table_id = loanRequestId)
    },
    uploadDocument() {
      return this.documentObjectClass.upload(this.token_auth, this.documents_list).then(response => {
        return response;
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      })
    },
    areDocumentsComplete() {
      let documentsComplete = true;

      if (this.existCheckBookInDocumentsTypeByLoanType) {
        if (!this.loadCheckCheckBook) {
          documentsComplete = false;
        }
      }
      if (this.existCheckIOInDocumentsTypeByLoanType) {
        if (!this.loadCheckIO) {
          documentsComplete = false;
        }
      }
      if (this.existCheckCredentialInDocumentsTypeByLoanType) {
        if (!this.loadCheckCredential) {
          documentsComplete = false;
        }
      }
      if (this.existCheckProofResidencyInDocumentsTypeByLoanType) {
        if (!this.loadCheckProofResidency) {
          documentsComplete = false;
        }
      }
      if (this.existCheckPublicScriptureInDocumentsTypeByLoanType) {
        if (!this.loadCheckPublicScripture) {
          documentsComplete = false;
        }
      }
      if (this.existCheckEvidenceEnlargementInDocumentsTypeByLoanType) {
        if (!this.loadCheckEvidenceEnlargement) {
          documentsComplete = false;
        }
      }
      if (this.existCheckAutoQuoteInDocumentsTypeByLoanType) {
        if (!this.loadCheckAutoQuote) {
          documentsComplete = false;
        }
      }
      if (this.existCheckCreditRequestInDocumentsTypeByLoanType) {
        if (!this.loadCheckCreditRequest) {
          documentsComplete = false;
        }
      }
      if (this.existCheckAccountStatusTypeByLoanType) {
        if (!this.loadCheckAccountStatus) {
          documentsComplete = false;
        }
      }
      
      if (!documentsComplete) {
        Swal.fire({
          title: "Aviso",
          text: "Favor de completar la carga de documentos.",
          icon: "warning",
        })
        return false;
      }

      return true;
    },
    isLogged() {
      let auth = JSON.parse(window.localStorage.getItem('authenticate'));
      if (auth == null) {
        this.$router.push({ name: 'AccessPreRequestLoan' });
      }
    },
    logout() {
      localStorage.clear();
      this.$router.push({ name: 'AccessPreRequestLoan' });
    },
    isLoanTypeActive (loanTypeItem) {
      return this.activeLoanTypeItem === loanTypeItem;
    },
    setLoanTypeButtonActive(loanTypeItem) {
      this.activeLoanTypeItem = loanTypeItem;
    },
    filterLoanCatalogByType(loanType) {
      this.setLoanTypeButtonActive(loanType);
      this.validateDocumentsTypeByLoanType(loanType);
      this.loan_catalog_filtered = this.loan_catalog.filter(loan => loan.category === loanType);
      this.documents_list = [];
      this.cleanValueChecks();
    },
    getDocumentsTypeByLoanType() {
      this.documentObjectClass.getDocumentsType(this.token_auth).then(response => {
        this.documentsTypeByLoanType = response.data.response.data;
        console.log("documents: ", response);
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    validateDocumentsTypeByLoanType(loanType) {
      let documentsTypeByLoanType = [];
      switch (loanType) {
        case "especial":
          documentsTypeByLoanType = this.documentsTypeByLoanType.especial;
          break;
        case "ordinario":
          documentsTypeByLoanType = this.documentsTypeByLoanType.ordinario;
          break;
        case "auto":
          documentsTypeByLoanType = this.documentsTypeByLoanType.auto;
          break;
        case "vivienda":
          documentsTypeByLoanType = this.documentsTypeByLoanType.remodelacion_de_vivienda;
          break;
      }

      this.validateExistDocumentTypeInDocumentsTypeByLoanType(documentsTypeByLoanType);
    },
    validateExistDocumentTypeInDocumentsTypeByLoanType(documentsType) {
      this.existCheckIOInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "IO") != -1 ? true : false;
      this.existCheckProofResidencyInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "CD") != -1 ? true : false;
      this.existCheckBookInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "TALON") != -1 ? true : false;
      this.existCheckCreditRequestInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "SOLCRED") != -1 ? true : false;
      this.existCheckCredentialInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "CRED17") != -1 ? true : false;
      this.existCheckAutoQuoteInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "COT") != -1 ? true : false;
      this.existCheckPublicScriptureInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "EP") != -1 ? true : false;
      this.existCheckEvidenceEnlargementInDocumentsTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "EPR") != -1 ? true : false;
      this.existCheckAccountStatusTypeByLoanType = documentsType.findIndex(a => a.abbreviation === "EC") != -1 ? true : false;
    },
    filterDocumentList(document, modalTitle) {
      this.documents_list_filtered = this.documents_list.filter(b => b.document_abbreviation === document);
      this.modalTitle = modalTitle;
      this.showModalListDocuments = true;
    }
  }
}
</script>
